import React, { useState } from 'react';

import { post_email_switch } from '../api';
import {
  email_switch_view,
  switch_confirm_label,
  switch_confirm_text,
  switch_error,
  switch_reason_error
} from './adapters';
import { switch_body } from './requests';

/* "Send payment emails to teachers". */
const ConfirmPanel = ({ shown, on_cancel, on_changed, on_stale }) => {
  const [target] = useState(!shown);
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [server_error, setServerError] = useState('');
  const [stale, setStale] = useState(false);
  const error = switch_reason_error(reason);
  const off = submitting || stale;

  const submit = () => {
    setTouched(true);
    if (error || off) return;
    setSubmitting(true);
    setServerError('');
    post_email_switch(switch_body(target, shown, reason))
      .then((d) => {
        setSubmitting(false);
        on_changed(d);
      })
      .catch((e) => {
        const r = switch_error(e);
        setSubmitting(false);
        setServerError(r.text);
        if (r.reload) {
          setStale(true);
          on_stale();
        }
      });
  };

  return (
    <div className="tp-pe-confirm" role="group" aria-label={switch_confirm_label(target)}>
      <div className="tp-strong">{switch_confirm_label(target)}?</div>
      <div className="tp-ctx">{switch_confirm_text(target)}</div>
      <div className="tp-field">
        <label htmlFor="tp-pe-switch-reason">Reason (required, recorded in the audit trail)</label>
        <textarea
          id="tp-pe-switch-reason"
          className="tp-textarea"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          onBlur={() => setTouched(true)}
          placeholder="Why is sending to teachers being switched?"
        />
        {touched && error ? (
          <span className="tp-neg" role="alert">
            {error}
          </span>
        ) : null}
        {server_error ? (
          <span className="tp-neg" role="alert">
            {server_error}
          </span>
        ) : null}
      </div>
      <div className="tp-modal-ft">
        <button
          type="button"
          className="tp-btn-ghost"
          onClick={submitting ? undefined : on_cancel}
          aria-disabled={submitting ? 'true' : undefined}
        >
          {stale ? 'Close' : 'Cancel'}
        </button>
        <button
          type="button"
          className={target ? 'tp-btn' : 'tp-btn tp-btn-danger'}
          onClick={off ? undefined : submit}
          aria-disabled={off ? 'true' : undefined}
        >
          {submitting ? 'Saving…' : switch_confirm_label(target)}
        </button>
      </div>
    </div>
  );
};

const SwitchCard = ({ data, load_error, on_retry, on_changed, on_stale }) => {
  const [confirming, setConfirming] = useState(false);
  const view = email_switch_view(data);

  if (!view) {
    return load_error ? (
      <div className="tp-banner tp-banner-error" role="alert">
        {load_error}{' '}
        <button type="button" className="tp-link" onClick={on_retry}>
          Try again
        </button>
      </div>
    ) : null;
  }

  return (
    <div className={`tp-pe-switch ${view.live ? 'tp-pe-switch-live' : 'tp-pe-switch-test'}`}>
      <div className="tp-pe-switch-hd">
        <span className={`tp-switch tp-switch-${view.enabled ? 'on' : 'off'}`}>{view.label}</span>
        {view.can_toggle && !confirming ? (
          <button type="button" className="tp-btn-out" onClick={() => setConfirming(true)}>
            {switch_confirm_label(!view.enabled)}
          </button>
        ) : null}
      </div>
      <div className="tp-ctx">{view.effect}</div>
      {view.last_change ? <div className="tp-hint">{view.last_change}</div> : null}
      {!view.can_toggle ? (
        <div className="tp-hint">Only a Teacher Payment super user can change this.</div>
      ) : null}
      {confirming ? (
        <ConfirmPanel
          shown={view.enabled}
          on_cancel={() => setConfirming(false)}
          on_changed={(d) => {
            setConfirming(false);
            on_changed(d);
          }}
          on_stale={on_stale}
        />
      ) : null}
    </div>
  );
};

export default SwitchCard;
